import React, { useState } from 'react'
import { Button } from '@mui/material'
import { makeKiddomPostRequest } from 'infrastructure/api'
import { useNotify } from 'shared/ui/Notify'
import {
  IInitiateImpersonationRequest,
  IImpersonationResponse,
} from 'infrastructure/api'
import Configs from 'infrastructure/config/environment'
import { useCurrentUserResource } from 'infrastructure/auth/auth.hooks'
import { ConfirmDialog } from 'shared/ui'

const InitiateImpersonationButton = ({
  targetUserID,
  onImpersonationSuccess,
}: {
  targetUserID: number
  onImpersonationSuccess: (encryptedData: string) => void
}) => {
  const [open, setOpen] = useState(false)
  const notify = useNotify()
  const currentUser = useCurrentUserResource()

  const initiateImpersonation = async () => {
    const url = `/v1/kat/users/impersonate/initiate`
    try {
      const body: IInitiateImpersonationRequest = {
        requester_user_id: currentUser!.id,
        target_user_id: targetUserID,
      }
      const { result, error } =
        await makeKiddomPostRequest<IImpersonationResponse>({
          kiddomPath: url,
          requestBody: body,
        })
      if (error != null) {
        notify(error, { type: 'error' })
      } else {
        // If successful, save the encrypted data to session storage
        const encryptedData = result.encrypted_data
        sessionStorage.setItem('impersonationData', encryptedData)

        // Notify the parent to update the UI
        onImpersonationSuccess(encryptedData)

        // Open a new tab to the main Kiddom app
        window.open(`${Configs().AppUrl}`, '_blank')
      }
    } catch {
      notify('Error occurred impersonating user.', {
        type: 'error',
      })
    }
    setOpen(false)
  }
  const title = 'Are you sure you want to impersonate the user?'
  const buttonText = 'Impersonate User'

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <ConfirmDialog
        title={title}
        open={open}
        onClose={handleClose}
        onConfirm={initiateImpersonation}
        cta="Impersonate"
      ></ConfirmDialog>
    </>
  )
}

export default InitiateImpersonationButton
